import { InfoOutlined } from "@mui/icons-material";
import { Box, ClickAwayListener, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
export default function InfoIcon(props) {
    var title = props.title;
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    return title ? /*#__PURE__*/ React.createElement(ClickAwayListener, {
        onClickAway: function () { return setOpen(false); }
    }, /*#__PURE__*/ React.createElement(Box, {
        lineHeight: 1
    }, /*#__PURE__*/ React.createElement(Tooltip, {
        arrow: true,
        title: title,
        open: open,
        onClose: function () { return setOpen(false); },
        placement: "right-end",
        disableFocusListener: true,
        disableHoverListener: true,
        disableTouchListener: true,
        slotProps: {
            tooltip: {
                sx: {
                    color: 'black',
                    borderRadius: 2,
                    bgcolor: 'white',
                    boxShadow: '0px 8px 10px 0px rgba(0,0,0,0.07)',
                    p: 2,
                    maxWidth: 'none'
                }
            },
            arrow: {
                sx: {
                    color: 'white'
                }
            },
            popper: {
                modifiers: [{
                        name: 'offset',
                        options: {
                            offset: [0, -8]
                        }
                    }]
            }
        }
    }, /*#__PURE__*/ React.createElement(IconButton
    // id="cell-icon"
    , {
        size: "small",
        disableRipple: true,
        onClick: function (e) {
            e.stopPropagation();
            setOpen(true);
        }
    }, /*#__PURE__*/ React.createElement(InfoOutlined, {
        color: "secondary"
    }))))) : null;
}
